import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        calculated: { type: Object },
        reported: { type: Object },
        colors: { type: Array },
    },
});
